module.exports = __webpack_public_path__ + "img/selected4-min.d0058a20.png";